import user from './user';
import routes from './routes';
import postcode from './postcode';
import customers from './customers';
import languages from './languages';
import events from './events';
import markets from './markets';
import sports from './sports';
import competitions from './competitions';
import participants from './participants';
import selections from './selections';
import tags from './tags';
import transactions from './transactions';
import { chats } from './trader-chat';
import notifications from './notifications';
import betslip from './betslip';
import bets from './bets';
import reports from './reports';
import payments from './payments';
import grades from './grades';
import marketTemplates from './market-templates';
import betTicker from './bet-ticker';
import roles from './roles';
import documents from './documents';
import permissions from './permissions';
import staff from './staff';
import audits from './audits';
import countries from './countries';
import liabilities from './liabilities';
import systemSettings from './system-settings';
import bonuses from './bonuses';
import ladders from './ladders';
import casino from './casino';
import fraudAndCompliance from './fraud-and-compliance';
import banners from './banners';
import relatedContingency from './related-contingency';

// eslint-disable-next-line import/no-default-export
export default {
    user,
    routes,
    postcode,
    customers,
    languages,
    events,
    markets,
    sports,
    competitions,
    participants,
    selections,
    tags,
    transactions,
    chats,
    notifications,
    betslip,
    bets,
    reports,
    grades,
    marketTemplates,
    betTicker,
    payments,
    roles,
    permissions,
    staff,
    audits,
    countries,
    liabilities,
    systemSettings,
    bonuses,
    documents,
    ladders,
    casino,
    relatedContingency,
    fraudAndCompliance,
    banners,
};
